import { IncomingHttpHeaders, IncomingMessage } from 'http';
import { getPlatformBySource, getSourceFromUA } from './getSSRPlatform';

export const getSSRContextData = (
  req: IncomingMessage & { headers?: IncomingHttpHeaders }
) => {
  const headers = req?.headers ?? {};
  const userAgent = headers['user-agent'] || '';
  const cookie = headers.cookie || '';

  const source = getSourceFromUA(userAgent);
  const isSSRWebView = userAgent.indexOf('miniApp') >= 0;
  const platform = getPlatformBySource(source, isSSRWebView);

  return {
    userAgent,
    cookie,
    source,
    isSSRWebView,
    platform
  };
};
